import { FC, useRef, createContext, createRef, RefObject, useContext } from 'react';
import { useScroll } from 'react-use';

type DrawerContextState = {
  contentScrollY: number;
  contentRef: RefObject<HTMLDivElement>;
};

export const defaultState: DrawerContextState = {
  contentScrollY: 0,
  contentRef: createRef(),
};

export const DrawerContext = createContext<DrawerContextState>(defaultState);

export const useDrawerContext = () => useContext(DrawerContext);

export const DrawerContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const { y: contentScrollY } = useScroll(contentRef);
  return (
    <DrawerContext.Provider value={{ contentRef, contentScrollY }}>
      {children}
    </DrawerContext.Provider>
  );
};
